module.exports = __webpack_public_path__ + "static/media/signup-illustration.8de6a6dd.svg";